module.exports = __webpack_public_path__ + "img/deviceGif.82572146.gif";